module.exports = __webpack_public_path__ + "img/boyuan_60.68923189.png";